import { sitePhotos, type SitePhotoKey } from '@/lib/site-imagery';

type PhotoProps = {
  photo: SitePhotoKey;
  className?: string;
  sizes?: string;
  priority?: boolean;
};

export function SiteImage({ photo, className, sizes = '(max-width: 600px) calc(100vw - 40px), (max-width: 900px) calc(100vw - 48px), 50vw', priority = false }: PhotoProps) {
  const asset = sitePhotos[photo];
  const directory = 'directory' in asset ? asset.directory : 'approved';
  const base = '/images/' + directory + '/' + asset.file;
  return (
    <img
      className={className}
      src={base + '-1080.webp'}
      srcSet={[480, 768, 1080, 1440].map(width => `${base}-${width}.webp ${width}w`).join(', ')}
      sizes={sizes}
      width={1440}
      height={960}
      alt={asset.alt}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : undefined}
      decoding="async"
    />
  );
}

export function SitePhoto({ className = '', ...props }: PhotoProps) {
  return (
    <figure className={'site-photo ' + className}>
      <SiteImage {...props} />
      <figcaption>{sitePhotos[props.photo].caption}</figcaption>
    </figure>
  );
}
